import * as Sentry from '@sentry/react';
import appData from '../../package.json';
import Environment from './Environment';
import {SENTRY_ENABLED_ENVIRONMENTS} from './App';

export const SENTRY_CONFIG = {
    enabled: SENTRY_ENABLED_ENVIRONMENTS.includes(Environment.current),
    release: `${appData.name}@${appData.version}`,
    environment: Environment.current,
    dsn: 'https://2f9cf1396ca3b442fbc2999f61a6390b@o4512266068033536.ingest.us.sentry.io/4512328506933248',
    integrations: [
        new Sentry.BrowserTracing({
            tracePropagationTargets: [
                'localhost',
                'https://kiosk-3d971--development-q2boteho.web.app/',
                'https://kiosk-3d971--staging-p1c8s52w.web.app/',
                'https://kiosk-3d971--preproduction-spys6x1l.web.app/',
                'https://kiosco.motiondisplays.com'
            ],
        }),
        new Sentry.Replay({
            maskAllText: false,
            blockAllMedia: false,
        }),
    ],
    tracesSampleRate: 1.0,
    replaysSessionSampleRate: 0.1,
    replaysOnErrorSampleRate: 1.0
};

export const setTags = (tags) => {
    if (SENTRY_CONFIG.enabled) {
        tags.forEach(tag => Sentry.setTag(tag.key, tag.value));
    }
};